import { QRCodeCanvas } from "qrcode.react";
import { fmtDateTime } from "@/lib/datetime";

// Boleto de estacionamiento con QR — presentacional puro (oculto en pantalla, visible al imprimir).
export const EntryThermalReceipt = ({ receipt, comisionCfg, paperWidth }) => {
  if (!receipt) return null;
  return (
    <div className={`thermal-receipt tr-w${paperWidth}`} data-testid="thermal-entry-ticket">
      <div className="tr-center tr-brand" data-testid="entry-brand">{comisionCfg?.nombre || receipt.sucursal}</div>
      {(receipt.direccion || comisionCfg?.direccion) ? <div className="tr-center tr-sm">{receipt.direccion || comisionCfg.direccion}</div> : null}
      {receipt.horarioHoy ? <div className="tr-center tr-sm" data-testid="entry-horario">Horario hoy: {receipt.horarioHoy}</div> : null}
      <div className="tr-sep">--------------------------------</div>
      <div className="tr-center tr-bold tr-lg">BOLETO DE ESTACIONAMIENTO</div>
      <div className="tr-center">Ingreso: {fmtDateTime(receipt.fecha_entrada)}</div>
      {receipt.tarifa_texto ? <div className="tr-center tr-bold" data-testid="entry-tarifa">Tarifa: {receipt.tarifa_texto}</div> : null}
      <div className="tr-qr" data-testid="entry-qr">
        <QRCodeCanvas value={receipt.qrUrl || receipt.folio} size={paperWidth === 58 ? 150 : 190} level="M" includeMargin />
      </div>
      <div className="tr-center tr-bold tr-lg" data-testid="entry-folio">{receipt.folio}</div>
      <div className="tr-sep">--------------------------------</div>
      {receipt.leyenda_corta ? <div className="tr-center tr-sm" data-testid="entry-leyenda">{receipt.leyenda_corta}</div> : null}
      <div className="tr-center tr-sm">Conserve este boleto. Preséntelo en</div>
      <div className="tr-center tr-sm">caseta para validar su salida.</div>
    </div>
  );
};

export default EntryThermalReceipt;
